export default __webpack_public_path__ + "static/1087-5a9dcef7bdb05920e860d675f6121212.gif";